import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SeoHead from '../../components/feature/SeoHead';
import TechGlowEffect from '../../components/feature/TechGlowEffect';
import { createTenantMatchRequest, getTenantMatchCount } from '../../lib/supabase';
import { supabase } from '../../lib/supabase';
import { useMobileTheme, getMobilePageTheme } from '../../hooks/useMobileTheme';
import LineOaModal from '../../components/feature/LineOaModal';
import FilterSummaryBar from './components/FilterSummaryBar';
import RegionDistributionSection from './components/RegionDistributionSection';
import AiMatchingOverlay from './components/AiMatchingOverlay';

const REGIONS = [
  '全部地區',
  '台北市', '新北市', '桃園市', '台中市', '台南市', '高雄市',
  '基隆市', '新竹市', '新竹縣', '苗栗縣', '彰化縣',
  '南投縣', '雲林縣', '嘉義市', '嘉義縣', '屏東縣',
  '宜蘭縣', '花蓮縣', '台東縣',
];

const CITY_DISTRICTS: Record<string, string[]> = {
  '台北市': ['中正區','大同區','中山區','松山區','大安區','萬華區','信義區','士林區','北投區','內湖區','南港區','文山區'],
  '新北市': ['板橋區','三重區','中和區','永和區','新莊區','新店區','樹林區','鶯歌區','三峽區','淡水區','汐止區','土城區','蘆洲區','五股區','泰山區','林口區','深坑區','石碇區','坪林區','三芝區','石門區','八里區','金山區','萬里區'],
  '桃園市': ['桃園區','中壢區','大溪區','楊梅區','蘆竹區','大園區','龜山區','八德區','龍潭區','平鎮區','新屋區','觀音區','復興區'],
  '台中市': ['中區','東區','南區','西區','北區','西屯區','南屯區','北屯區','豐原區','東勢區','大甲區','清水區','沙鹿區','梧棲區','后里區','神岡區','潭子區','大雅區','烏日區','大肚區','龍井區','霧峰區','太平區','大里區'],
  '台南市': ['中西區','東區','南區','北區','安平區','安南區','永康區','歸仁區','新化區','仁德區','關廟區','官田區','麻豆區','佳里區','西港區','七股區','將軍區','學甲區','北門區','新營區','後壁區','白河區','東山區','六甲區','下營區','柳營區','鹽水區','善化區','新市區','安定區'],
  '高雄市': ['楠梓區','左營區','鼓山區','三民區','鹽埕區','前金區','苓雅區','前鎮區','旗津區','小港區','鳳山區','大寮區','林園區','仁武區','大樹區','大社區','岡山區','路竹區','橋頭區','梓官區','彌陀區','永安區','燕巢區','田寮區','阿蓮區','茄萣區','湖內區','旗山區','美濃區'],
  '新竹市': ['東區','北區','香山區'],
  '新竹縣': ['竹北市','竹東鎮','新埔鎮','關西鎮','湖口鄉','新豐鄉','芎林鄉','橫山鄉','北埔鄉','峨眉鄉','寶山鄉','五峰鄉','尖石鄉'],
  '嘉義市': ['東區','西區'],
  '嘉義縣': ['太保市','朴子市','布袋鎮','大林鎮','民雄鄉','溪口鄉','新港鄉','六腳鄉','東石鄉','義竹鄉','鹿草鄉','水上鄉','中埔鄉','竹崎鄉','梅山鄉','番路鄉','大埔鄉','阿里山鄉'],
  '屏東縣': ['屏東市','潮州鎮','東港鎮','恆春鎮','萬丹鄉','長治鄉','麟洛鄉','九如鄉','里港鄉','鹽埔鄉','高樹鄉','萬巒鄉','內埔鄉','竹田鄉','新埤鄉','枋寮鄉','新園鄉','崁頂鄉','林邊鄉','南州鄉','佳冬鄉','琉球鄉','車城鄉','滿州鄉','枋山鄉'],
  '彰化縣': ['彰化市','鹿港鎮','和美鎮','線西鄉','伸港鄉','福興鄉','秀水鄉','花壇鄉','芬園鄉','員林市','溪湖鎮','田中鎮','大村鄉','埔鹽鄉','埔心鄉','永靖鄉','社頭鄉','二水鄉','北斗鎮','二林鎮','田尾鄉','埤頭鄉','芳苑鄉','大城鄉','竹塘鄉','溪州鄉'],
};

const ROOM_OPTIONS = ['套房', '1房', '2房', '3房', '4房以上'];

const PROPERTY_TYPE_OPTIONS = [
  { value: '住宅', icon: 'ri-home-4-line', label: '住宅' },
  { value: '套房', icon: 'ri-door-closed-line', label: '套房' },
  { value: '透天厝', icon: 'ri-building-line', label: '透天厝' },
  { value: '店面', icon: 'ri-store-2-line', label: '店面' },
  { value: '廠房', icon: 'ri-building-4-line', label: '廠房' },
];

const ADMIN_NOTIFY_URL = 'https://olopruztyyvtgxmqbyma.supabase.co/functions/v1/admin-notify';

export default function AiMatchPage() {
  const [step, setStep] = useState<'form' | 'success'>('form');
  const [totalWaitingCount, setTotalWaitingCount] = useState(0);
  const [showLineModal, setShowLineModal] = useState(false);
  const [showMatchingOverlay, setShowMatchingOverlay] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);

  // AI 配對頁強制使用科技主題，讓整體體驗更沉浸
  const { theme: _userTheme } = useMobileTheme();
  const theme = 'tech' as const;
  const pt = getMobilePageTheme(theme);

  // 按鈕樣式（固定 tech 版）
  const btnActive = 'border-teal-500 bg-teal-500 text-white shadow-teal-500/30 shadow-md';
  const btnInactive = 'border-gray-700 bg-gray-800 text-gray-300 hover:border-teal-500/50 hover:bg-gray-700';
  const inputCls = 'w-full px-4 py-3 border-2 rounded-xl text-sm focus:outline-none transition-colors bg-gray-900 border-gray-700 text-white placeholder:text-gray-500 focus:border-teal-500';

  // 表單欄位
  const [region, setRegion] = useState('');
  const [selectedDistricts, setSelectedDistricts] = useState<string[]>([]);
  const [maxPrice, setMaxPrice] = useState(25000);
  const [minArea, setMinArea] = useState<number | ''>('');
  const [selectedRooms, setSelectedRooms] = useState<string[]>([]);
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);
  const [petAllowed, setPetAllowed] = useState(false);
  const [moveInTime, setMoveInTime] = useState('');
  const [notes, setNotes] = useState('');
  const [contactName, setContactName] = useState('');
  const [contactPhone, setContactPhone] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [lineId, setLineId] = useState('');

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});

  const toggleRoom = (r: string) =>
    setSelectedRooms(prev => prev.includes(r) ? prev.filter(x => x !== r) : [...prev, r]);

  const toggleType = (t: string) =>
    setSelectedTypes(prev => prev.includes(t) ? prev.filter(x => x !== t) : [...prev, t]);

  const clearRegion = () => { setRegion(''); setSelectedDistricts([]); };
  const clearRooms = () => setSelectedRooms([]);
  const clearTypes = () => setSelectedTypes([]);
  const clearPet = () => setPetAllowed(false);
  const clearArea = () => setMinArea('');
  const clearMoveIn = () => setMoveInTime('');

  const validate = () => {
    const e: Record<string, string> = {};
    if (!region) e.region = '請選擇地區';
    if (selectedRooms.length === 0) e.rooms = '請至少選擇一種房型';
    if (!contactName.trim()) e.contactName = '請輸入姓名';
    if (!contactPhone.trim()) e.contactPhone = '請輸入電話';
    if (!contactEmail.trim()) e.contactEmail = '請輸入 Email';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactEmail)) e.contactEmail = 'Email 格式不正確';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    setIsSubmitting(true);
    setShowMatchingOverlay(true);

    // 最短展示時間 5 秒，確保動畫播放完整
    const minDelay = new Promise(res => setTimeout(res, 5000));

    try {
      const { data: { user } } = await supabase.auth.getUser();
      const regionValue = selectedDistricts.length > 0
        ? `${region}(${selectedDistricts.join('、')})`
        : region;

      const apiCall = createTenantMatchRequest({
        region: regionValue,
        max_price: maxPrice,
        min_area: minArea === '' ? undefined : Number(minArea),
        rooms: selectedRooms,
        pet_allowed: petAllowed,
        contact_name: contactName.trim(),
        contact_phone: contactPhone.trim(),
        contact_email: contactEmail.trim(),
        line_id: lineId.trim() || undefined,
        user_id: user?.id,
        session_token: user ? undefined : crypto.randomUUID(),
      });

      const [freshCount] = await Promise.all([
        getTenantMatchCount(),
        apiCall,
        minDelay,
      ]);

      try {
        await fetch(ADMIN_NOTIFY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            eventType: 'new_tenant_request',
            data: { contactName: contactName.trim(), region: regionValue, maxPrice },
          }),
        });
      } catch { /* 通知失敗不影響主流程 */ }

      setTotalWaitingCount(64 + freshCount);
      setShowMatchingOverlay(false);
      setIsSubmitting(false);

      setTimeout(() => {
        setStep('success');
        setSuccessVisible(false);
        requestAnimationFrame(() => {
          setTimeout(() => setSuccessVisible(true), 50);
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });

        const alreadyJoined = !!localStorage.getItem('line_oa_friend_prompted');
        if (!alreadyJoined) {
          setTimeout(() => setShowLineModal(true), 800);
        }
      }, 200);

    } catch (err) {
      console.error(err);
      await minDelay;
      setShowMatchingOverlay(false);
      setIsSubmitting(false);
      setErrors({ submit: '提交失敗，請稍後再試' });
    }
  };

  return (
    <div className={`min-h-screen ${pt.pageBg} relative`}>

      {/* 全頁科技光暈背景 */}
      <TechGlowEffect intensity="normal" className="fixed inset-0 pointer-events-none z-0 overflow-hidden" />

      {/* 動態浮動粒子 + 掃描線 CSS */}
      <style>{`
        @keyframes floatDot {
          0%, 100% { transform: translateY(0) scale(1); opacity: 0.3; }
          33%       { transform: translateY(-18px) scale(1.2); opacity: 0.7; }
          66%       { transform: translateY(10px) scale(0.8); opacity: 0.2; }
        }
        @keyframes scanMove {
          0%   { transform: translateY(-120px); }
          100% { transform: translateY(100vh); }
        }
        @keyframes borderGlow {
          0%, 100% { border-color: rgba(45,212,191,0.25); }
          50%       { border-color: rgba(45,212,191,0.55); box-shadow: 0 0 14px rgba(45,212,191,0.10); }
        }
        .ai-section-glow { animation: borderGlow 4s ease-in-out infinite; }
        .tech-float-1 { animation: floatDot 5.2s ease-in-out infinite; }
        .tech-float-2 { animation: floatDot 7.1s ease-in-out infinite 1.2s; }
        .tech-float-3 { animation: floatDot 6.4s ease-in-out infinite 2.8s; }
        .tech-float-4 { animation: floatDot 8.3s ease-in-out infinite 0.5s; }
        .tech-float-5 { animation: floatDot 4.9s ease-in-out infinite 3.5s; }
        .ai-scan-line {
          animation: scanMove 9s linear infinite;
          background: linear-gradient(to bottom, transparent, rgba(45,212,191,0.05), transparent);
          height: 120px;
          position: absolute;
          left: 0; right: 0; top: 0;
          pointer-events: none;
        }
      `}</style>

      {/* 浮動粒子層 */}
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
        {[
          { cls: 'tech-float-1', left: '8%',  top: '20%', size: 3 },
          { cls: 'tech-float-2', left: '85%', top: '35%', size: 2 },
          { cls: 'tech-float-3', left: '55%', top: '65%', size: 4 },
          { cls: 'tech-float-4', left: '25%', top: '75%', size: 2 },
          { cls: 'tech-float-5', left: '70%', top: '15%', size: 3 },
          { cls: 'tech-float-1', left: '40%', top: '45%', size: 2 },
          { cls: 'tech-float-3', left: '92%', top: '70%', size: 3 },
          { cls: 'tech-float-2', left: '15%', top: '55%', size: 2 },
        ].map((dot, i) => (
          <div key={i} className={`absolute rounded-full ${dot.cls}`} style={{
            left: dot.left, top: dot.top,
            width: `${dot.size * 2}px`, height: `${dot.size * 2}px`,
            backgroundColor: '#2dd4bf',
          }} />
        ))}
        <div className="ai-scan-line" />
      </div>

      <SeoHead
        title="AI 租客媒合｜設定條件有房自動通知 台北 台中 高雄 - 藍舍AI地產"
        description="填寫一次租屋需求，AI 自動比對台灣六都全平台房源，台北、新北、桃園、台中、台南、高雄屋主直租，有符合條件的新房源上架即時 Email + LINE 雙重通知，零仲介費找房。"
        keywords="AI租客媒合,自動配對租屋,找房通知,零仲介費找房,台北租屋通知,台中租屋配對,高雄租屋AI媒合,屋主直租配對,租屋需求媒合,AI找房平台台灣"
        canonical="/ai-match"
        lastModified="2026-03-18"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "AI 租客媒合 - 藍舍AI地產",
          "url": `${import.meta.env.VITE_SITE_URL || 'https://ailanshe.com'}/ai-match`,
          "description": "填寫租屋需求，AI 自動比對台灣六都房源，有符合條件的房源即時通知",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {"@type": "ListItem", "position": 1, "name": "首頁", "item": `${import.meta.env.VITE_SITE_URL || 'https://ailanshe.com'}/`},
              {"@type": "ListItem", "position": 2, "name": "AI 租客媒合", "item": `${import.meta.env.VITE_SITE_URL || 'https://ailanshe.com'}/ai-match`}
            ]
          }
        }}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative min-h-[300px] sm:min-h-[340px] flex items-center overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/47dc490d7211469049811bfceab4028f.jpg"
          alt="AI 媒合找房"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0" style={{ background: pt.heroOverlay }}></div>
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-gray-950 to-transparent"></div>
          <div className="absolute inset-0" style={{ background: 'repeating-linear-gradient(0deg,transparent,transparent 40px,rgba(45,212,191,.018) 40px,rgba(45,212,191,.018) 41px)' }}></div>
          <div className="absolute inset-0" style={{ background: 'repeating-linear-gradient(90deg,transparent,transparent 100px,rgba(45,212,191,.009) 100px,rgba(45,212,191,.009) 101px)' }}></div>
        </div>

        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 pt-20 sm:pt-24 pb-10 sm:pb-14">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-teal-400/30 bg-teal-400/10 mb-4">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-teal-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-teal-400"></span>
              </span>
              <span className="text-teal-300 text-xs font-mono tracking-wider">AI_MATCH_ENGINE · ONLINE</span>
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-3 sm:mb-4 leading-tight">
              告訴 AI 你要的房<br />
              <span className="text-teal-300">讓房源主動來找你</span>
            </h1>
            <p className="text-sm sm:text-base text-white/80 mb-5 sm:mb-6 leading-relaxed">
              填寫一次需求，AI 自動比對台灣六都房源<br />
              有符合的新房源上架，第一時間 Email + LINE 雙重通知
            </p>
            <div className="flex flex-wrap gap-3">
              {[
                { icon: 'ri-robot-2-line', text: 'AI 自動比對' },
                { icon: 'ri-notification-3-line', text: '即時通知' },
                { icon: 'ri-money-dollar-circle-line', text: '零仲介費' },
              ].map(item => (
                <div key={item.text} className="flex items-center gap-1.5 text-white/90 text-xs sm:text-sm">
                  <div className="w-6 h-6 sm:w-7 sm:h-7 flex items-center justify-center bg-teal-500/40 rounded-lg">
                    <i className={`${item.icon} text-teal-300 text-sm sm:text-base`}></i>
                  </div>
                  {item.text}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 如何運作 */}
      <section className="relative py-7 sm:py-10 border-b bg-gray-900/80 border-gray-800">
        <TechGlowEffect intensity="subtle" className="absolute inset-0 overflow-hidden pointer-events-none" />
        <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10">
          <div className="text-center mb-5">
            <p className="text-xs font-mono tracking-widest text-teal-400/70 mb-1">// HOW_IT_WORKS</p>
            <h2 className="text-base font-black text-white">三步驟 · AI 自動完成媒合</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
            {[
              { step: '01', icon: 'ri-file-list-3-line', title: '填寫需求', desc: '設定地區、租金上限、房型等條件，一分鐘完成' },
              { step: '02', icon: 'ri-cpu-line', title: 'AI 自動比對', desc: '有屋主上架新房源，AI 立即與你的條件做媒合' },
              { step: '03', icon: 'ri-notification-3-line', title: '收到通知', desc: '符合條件的房源出現時，Email + LINE 同步推送給你' },
            ].map((item, idx) => (
              <div key={item.step} className="flex items-center sm:items-start gap-4 p-4 rounded-2xl border bg-gray-800/60 border-gray-700 ai-section-glow relative overflow-hidden">
                <div className="absolute right-3 bottom-2 text-5xl font-black text-teal-400/5 select-none pointer-events-none">{item.step}</div>
                <div className="relative flex-shrink-0">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gray-700 border-2 border-teal-500/40 rounded-xl">
                    <i className={`${item.icon} text-lg sm:text-xl text-teal-400`}></i>
                  </div>
                  <span className="absolute -top-2 -right-2 w-5 h-5 bg-teal-500 text-white text-xs font-black rounded-full flex items-center justify-center">{idx + 1}</span>
                </div>
                <div>
                  <p className="font-bold text-sm mb-0.5 text-white">{item.title}</p>
                  <p className="text-xs leading-relaxed text-gray-400">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 主內容 */}
      <section className="py-10 sm:py-14 bg-gray-950 relative">
        <TechGlowEffect intensity="subtle" className="absolute inset-0 overflow-hidden pointer-events-none" />
        <div className="max-w-3xl mx-auto px-4 sm:px-6 relative z-10">

          {/* AI 配對動畫覆蓋層 */}
          <AiMatchingOverlay visible={showMatchingOverlay} theme={theme} />

          {step === 'success' ? (
            <div
              className="text-center py-12 transition-all duration-700"
              style={{ opacity: successVisible ? 1 : 0, transform: successVisible ? 'translateY(0)' : 'translateY(20px)' }}
            >
              {/* 成功動畫核心 */}
              <div className="relative w-32 h-32 mx-auto mb-8">
                <div className="absolute inset-0 rounded-full animate-ping" style={{ background: 'rgba(45,212,191,0.12)' }}></div>
                <div className="absolute inset-2 rounded-full animate-pulse" style={{ background: 'rgba(45,212,191,0.08)', animationDelay: '0.3s' }}></div>
                <div className="absolute inset-4 rounded-full flex items-center justify-center border-4 border-teal-400 bg-teal-50/10">
                  <i className="ri-check-double-line text-3xl text-teal-400"></i>
                </div>
                {[
                  { icon: 'ri-robot-2-fill', angle: 0 },
                  { icon: 'ri-notification-3-fill', angle: 120 },
                  { icon: 'ri-shield-check-fill', angle: 240 },
                ].map((sat, i) => {
                  const rad = (sat.angle * Math.PI) / 180;
                  const x = 50 + 42 * Math.cos(rad - Math.PI / 2);
                  const y = 50 + 42 * Math.sin(rad - Math.PI / 2);
                  return (
                    <div key={i} className="absolute w-7 h-7 flex items-center justify-center rounded-full bg-gray-800 border-2 border-teal-500/50"
                      style={{ left: `${x}%`, top: `${y}%`, transform: 'translate(-50%, -50%)' }}>
                      <i className={`${sat.icon} text-xs text-teal-400`}></i>
                    </div>
                  );
                })}
              </div>

              <div className="mb-4">
                <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-bold mb-3 bg-teal-500/15 text-teal-400">
                  <i className="ri-sparkling-2-fill"></i>AI 配對任務已啟動
                </div>
                <h2 className="text-3xl sm:text-4xl font-black text-white mb-2">需求已送出！</h2>
                <p className="text-base text-gray-400">AI 正在全台掃描符合你條件的房源</p>
              </div>

              <div className="max-w-sm mx-auto rounded-2xl border p-4 mb-6 bg-gray-800/60 border-gray-700 ai-section-glow">
                {[
                  { icon: 'ri-check-line', text: '需求條件已記錄' },
                  { icon: 'ri-cpu-line', text: 'AI 比對引擎已啟動' },
                  { icon: 'ri-notification-3-line', text: '通知系統監控中', pulse: true },
                ].map((item, i) => (
                  <div key={i} className={`flex items-center gap-3 py-2 ${i < 2 ? 'border-b border-gray-700' : ''}`}>
                    <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-teal-500">
                      <i className={`${item.icon} text-white text-xs ${item.pulse ? 'animate-pulse' : ''}`}></i>
                    </div>
                    <span className="text-sm font-medium text-white">{item.text}</span>
                    {item.pulse && (
                      <span className="relative flex h-2 w-2 ml-auto flex-shrink-0">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                      </span>
                    )}
                  </div>
                ))}
              </div>

              <div className="inline-flex items-center gap-3 mx-auto mb-6 px-6 py-3.5 bg-teal-500/10 border-2 border-teal-500/30 rounded-2xl">
                <div className="flex -space-x-2">
                  {[1,2,3].map(i => (
                    <div key={i} className="w-7 h-7 rounded-full bg-gradient-to-br from-teal-400 to-teal-600 border-2 border-gray-800 flex items-center justify-center flex-shrink-0">
                      <i className="ri-user-line text-white text-xs"></i>
                    </div>
                  ))}
                </div>
                <div className="text-left">
                  <p className="text-xs text-teal-300 font-medium leading-none mb-0.5">你加入了！目前共</p>
                  <p className="text-lg font-black text-teal-300 leading-none tabular-nums">
                    {totalWaitingCount} <span className="text-sm font-bold">位租客等待中</span>
                  </p>
                </div>
                <div className="relative flex h-2.5 w-2.5 flex-shrink-0">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500"></span>
                </div>
              </div>

              <p className="text-sm text-gray-400 mb-8 leading-relaxed">
                有新房源上架，立即寄送通知到 <strong className="text-white">{contactEmail}</strong>
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
                <Link to="/regions" className="inline-flex items-center gap-2 px-7 py-3 bg-teal-500 hover:bg-teal-400 text-white rounded-full font-bold text-sm transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-search-line"></i>立即搜尋現有房源
                </Link>
                <button onClick={() => { setStep('form'); setSuccessVisible(false); }}
                  className="inline-flex items-center gap-2 px-7 py-3 border-2 border-gray-700 text-gray-300 hover:border-gray-600 rounded-full font-medium text-sm transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-add-line"></i>再新增一筆需求
                </button>
              </div>

              <div className="max-w-md mx-auto bg-[#06C755]/8 border-2 border-[#06C755]/25 rounded-2xl p-5 text-left">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0" style={{ backgroundColor: '#06C755' }}>
                    <i className="ri-line-fill text-white text-xl"></i>
                  </div>
                  <div>
                    <p className="font-bold text-white text-sm mb-1">別忘了加入 LINE 官方帳號</p>
                    <p className="text-xs text-gray-400 leading-relaxed mb-3">加入後配對成功時，直接從 LINE 收到通知，不怕漏掉理想房源！</p>
                    <a href="https://line.me/R/ti/p/@381szuhf" target="_blank" rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-white text-xs font-bold cursor-pointer whitespace-nowrap"
                      style={{ backgroundColor: '#06C755' }}>
                      <i className="ri-user-add-line"></i>加入 LINE 官方帳號
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="mb-6 sm:mb-8 text-center">
                <p className="text-xs font-mono tracking-widest text-teal-400/60 mb-2">// INPUT_YOUR_REQUIREMENTS</p>
                <h2 className="text-xl sm:text-2xl font-black text-white mb-1">填寫你的租屋需求</h2>
                <p className="text-sm text-gray-400">填寫越詳細，AI 媒合越精準</p>
              </div>

              <div className="mb-6">
                <RegionDistributionSection theme={theme} />
              </div>

              {errors.submit && (
                <div className="mb-6 px-4 py-3 bg-red-900/40 border border-red-700 rounded-xl text-sm text-red-300 flex items-center gap-2">
                  <i className="ri-error-warning-line text-red-400"></i>
                  {errors.submit}
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-5 sm:space-y-8">

                <FilterSummaryBar
                  theme={theme}
                  region={region}
                  selectedDistricts={selectedDistricts}
                  maxPrice={maxPrice}
                  minArea={minArea}
                  selectedRooms={selectedRooms}
                  selectedTypes={selectedTypes}
                  petAllowed={petAllowed}
                  moveInTime={moveInTime}
                  notes={notes}
                  onClearRegion={clearRegion}
                  onClearRooms={clearRooms}
                  onClearTypes={clearTypes}
                  onClearPet={clearPet}
                  onClearArea={clearArea}
                  onClearMoveIn={clearMoveIn}
                />

                {/* 地區 */}
                <div className="bg-gray-800/80 rounded-2xl p-4 sm:p-6 border border-gray-700 ai-section-glow relative overflow-hidden">
                  <TechGlowEffect intensity="subtle" className="absolute inset-0 overflow-hidden pointer-events-none" />
                  <h3 className="font-bold text-white mb-3 sm:mb-4 flex items-center gap-2 text-sm sm:text-base relative z-10">
                    <div className="w-7 h-7 flex items-center justify-center bg-teal-500 rounded-lg">
                      <i className="ri-map-pin-line text-white text-sm"></i>
                    </div>
                    租屋地區 <span className="text-red-400 text-sm">*</span>
                    <span className="ml-auto text-[10px] font-mono text-teal-400/50">LOCATION_FILTER</span>
                  </h3>
                  <div className="flex flex-wrap gap-2 mb-4 relative z-10">
                    {REGIONS.map(r => (
                      <button key={r} type="button" onClick={() => { setRegion(r); setSelectedDistricts([]); }}
                        className={`px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-xl text-xs sm:text-sm font-medium border-2 transition-all cursor-pointer whitespace-nowrap ${region === r ? btnActive : btnInactive}`}>
                        {r}
                      </button>
                    ))}
                  </div>

                  {region && CITY_DISTRICTS[region] && (
                    <div className="mt-2 pt-4 border-t border-gray-700 relative z-10">
                      <div className="flex items-center justify-between mb-3">
                        <p className="text-sm font-semibold text-gray-300 flex items-center gap-1.5">
                          <i className="ri-map-2-line text-teal-400 text-base"></i>
                          選擇 {region} 的行政區
                          <span className="text-xs text-gray-400 font-normal">（可複選）</span>
                        </p>
                        {selectedDistricts.length > 0 && (
                          <button type="button" onClick={() => setSelectedDistricts([])} className="text-xs text-gray-400 hover:text-gray-300 underline cursor-pointer whitespace-nowrap">清除全選</button>
                        )}
                      </div>
                      <div className="flex flex-wrap gap-1.5">
                        {CITY_DISTRICTS[region].map(d => {
                          const active = selectedDistricts.includes(d);
                          return (
                            <button key={d} type="button"
                              onClick={() => setSelectedDistricts(prev => active ? prev.filter(x => x !== d) : [...prev, d])}
                              className={`px-3 py-1.5 rounded-lg text-xs font-medium border transition-all cursor-pointer whitespace-nowrap flex items-center gap-1 ${active ? btnActive : btnInactive}`}>
                              {active && <i className="ri-check-line text-xs"></i>}
                              {d}
                            </button>
                          );
                        })}
                      </div>
                      {selectedDistricts.length > 0 && (
                        <div className="mt-3 px-3 py-2 bg-teal-500/10 border border-teal-500/30 rounded-xl flex items-start gap-2">
                          <i className="text-teal-400 text-sm flex-shrink-0 mt-0.5 ri-checkbox-multiple-line"></i>
                          <p className="text-xs text-teal-300 leading-relaxed">已選：<strong>{selectedDistricts.join('、')}</strong></p>
                        </div>
                      )}
                    </div>
                  )}
                  {errors.region && <p className="mt-2 text-xs text-red-400 flex items-center gap-1 relative z-10"><i className="ri-error-warning-line"></i>{errors.region}</p>}
                </div>

                {/* 租金上限 */}
                <div className="bg-gray-800/80 rounded-2xl p-4 sm:p-6 border border-gray-700 ai-section-glow relative overflow-hidden">
                  <TechGlowEffect intensity="subtle" className="absolute inset-0 overflow-hidden pointer-events-none" />
                  <h3 className="font-bold text-white mb-3 sm:mb-4 flex items-center gap-2 text-sm sm:text-base relative z-10">
                    <div className="w-7 h-7 flex items-center justify-center bg-teal-500 rounded-lg">
                      <i className="ri-money-dollar-circle-line text-white text-sm"></i>
                    </div>
                    月租金上限 <span className="text-red-400 text-sm">*</span>
                    <span className="ml-auto text-[10px] font-mono text-teal-400/50">BUDGET_RANGE</span>
                  </h3>
                  <div className="space-y-4 relative z-10">
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-gray-400">NT$ 5,000</span>
                      <div className="px-3 sm:px-5 py-1.5 sm:py-2 bg-teal-500 rounded-xl">
                        <span className="text-base sm:text-xl font-black text-white">NT$ {maxPrice.toLocaleString()}</span>
                        <span className="text-xs text-white/80 ml-1">/月</span>
                      </div>
                      <span className="text-xs text-gray-400">NT$ 100,000</span>
                    </div>
                    <input type="range" min="5000" max="100000" step="1000" value={maxPrice}
                      onChange={e => setMaxPrice(Number(e.target.value))}
                      className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-teal-500" />
                    <div className="flex flex-wrap gap-1.5 sm:gap-2">
                      {[10000, 15000, 20000, 25000, 30000, 40000, 50000].map(p => (
                        <button key={p} type="button" onClick={() => setMaxPrice(p)}
                          className={`px-2.5 sm:px-3 py-1 sm:py-1.5 rounded-lg text-xs font-semibold border-2 transition-all cursor-pointer whitespace-nowrap ${maxPrice === p ? btnActive : btnInactive}`}>
                          {p.toLocaleString()}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* 房型 + 坪數 */}
                <div className="bg-gray-800/80 rounded-2xl p-4 sm:p-6 border border-gray-700 ai-section-glow relative overflow-hidden">
                  <TechGlowEffect intensity="subtle" className="absolute inset-0 overflow-hidden pointer-events-none" />
                  <h3 className="font-bold text-white mb-3 sm:mb-4 flex items-center gap-2 text-sm sm:text-base relative z-10">
                    <div className="w-7 h-7 flex items-center justify-center bg-teal-500 rounded-lg">
                      <i className="ri-door-line text-white text-sm"></i>
                    </div>
                    房型需求 <span className="text-red-400 text-sm">*</span>
                    <span className="text-xs font-normal text-gray-400 ml-1">（可多選）</span>
                    <span className="ml-auto text-[10px] font-mono text-teal-400/50">ROOM_TYPE</span>
                  </h3>
                  <div className="flex flex-wrap gap-2 mb-4 sm:mb-5 relative z-10">
                    {ROOM_OPTIONS.map(r => (
                      <button key={r} type="button" onClick={() => toggleRoom(r)}
                        className={`flex items-center gap-1.5 px-4 py-2.5 rounded-xl text-sm font-semibold border-2 transition-all cursor-pointer whitespace-nowrap ${selectedRooms.includes(r) ? btnActive : btnInactive}`}>
                        {selectedRooms.includes(r) && <i className="ri-check-line text-sm"></i>}
                        {r}
                      </button>
                    ))}
                  </div>
                  {errors.rooms && <p className="mb-4 text-xs text-red-400 flex items-center gap-1 relative z-10"><i className="ri-error-warning-line"></i>{errors.rooms}</p>}
                  <div className="grid grid-cols-2 gap-3 sm:gap-4 relative z-10">
                    <div>
                      <label className="block text-xs font-semibold text-gray-300 mb-2">最低坪數（選填）</label>
                      <div className="relative">
                        <input type="number" min="0" step="1" value={minArea}
                          onChange={e => setMinArea(e.target.value === '' ? '' : Number(e.target.value))}
                          placeholder="不限" className={inputCls + ' pr-10'} />
                        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-400">坪</span>
                      </div>
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-gray-300 mb-2">預計入住時間（選填）</label>
                      <input type="month" value={moveInTime} onChange={e => setMoveInTime(e.target.value)} className={inputCls + ' cursor-pointer'} />
                    </div>
                  </div>
                </div>

                {/* 物件類型偏好 */}
                <div className="bg-gray-800/80 rounded-2xl p-4 sm:p-6 border border-gray-700 ai-section-glow relative overflow-hidden">
                  <TechGlowEffect intensity="subtle" className="absolute inset-0 overflow-hidden pointer-events-none" />
                  <h3 className="font-bold text-white mb-1 flex items-center gap-2 text-sm sm:text-base relative z-10">
                    <div className="w-7 h-7 flex items-center justify-center bg-teal-500 rounded-lg">
                      <i className="ri-building-line text-white text-sm"></i>
                    </div>
                    物件類型偏好
                    <span className="text-xs font-normal text-gray-400 ml-1">（選填，可多選）</span>
                    <span className="ml-auto text-[10px] font-mono text-teal-400/50">PROPERTY_TYPE</span>
                  </h3>
                  <p className="text-xs text-gray-400 mb-4 relative z-10">不選則匹配所有類型</p>
                  <div className="flex flex-wrap gap-1.5 sm:gap-2 relative z-10">
                    {PROPERTY_TYPE_OPTIONS.map(t => (
                      <button key={t.value} type="button" onClick={() => toggleType(t.value)}
                        className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold border-2 transition-all cursor-pointer whitespace-nowrap ${selectedTypes.includes(t.value) ? btnActive : btnInactive}`}>
                        <i className={`${t.icon} text-base`}></i>
                        {t.label}
                      </button>
                    ))}
                  </div>
                </div>

                {/* 其他條件 */}
                <div className="bg-gray-800/80 rounded-2xl p-4 sm:p-6 border border-gray-700 ai-section-glow relative overflow-hidden">
                  <TechGlowEffect intensity="subtle" className="absolute inset-0 overflow-hidden pointer-events-none" />
                  <h3 className="font-bold text-white mb-3 sm:mb-4 flex items-center gap-2 text-sm sm:text-base relative z-10">
                    <div className="w-7 h-7 flex items-center justify-center bg-teal-500 rounded-lg">
                      <i className="ri-settings-3-line text-white text-sm"></i>
                    </div>
                    其他條件
                    <span className="ml-auto text-[10px] font-mono text-teal-400/50">EXTRA_FILTERS</span>
                  </h3>
                  <label className="flex items-center gap-3 p-4 bg-gray-900/60 border-2 border-gray-700 hover:border-teal-500/50 rounded-xl cursor-pointer transition-colors mb-4 relative z-10">
                    <input type="checkbox" checked={petAllowed} onChange={e => setPetAllowed(e.target.checked)} className="w-5 h-5 accent-teal-500 cursor-pointer rounded" />
                    <div className="flex items-center gap-2">
                      <i className="ri-bear-smile-line text-xl text-teal-400"></i>
                      <div>
                        <p className="text-sm font-bold text-white">需要寵物友善</p>
                        <p className="text-xs text-gray-400">只媒合允許飼養寵物的房源</p>
                      </div>
                    </div>
                  </label>
                  <div className="relative z-10">
                    <label className="block text-xs font-semibold text-gray-300 mb-2">補充說明（選填）</label>
                    <textarea value={notes} onChange={e => setNotes(e.target.value)}
                      placeholder="例如：需要停車位、希望近捷運站、需要獨立套房..."
                      rows={3} maxLength={200} className={inputCls + ' resize-none'} />
                    <p className="text-right text-xs text-gray-400 mt-1">{notes.length}/200</p>
                  </div>
                </div>

                {/* 聯絡資訊 */}
                <div className="bg-gray-800/80 rounded-2xl p-4 sm:p-6 border border-gray-700 ai-section-glow relative overflow-hidden">
                  <TechGlowEffect intensity="subtle" className="absolute inset-0 overflow-hidden pointer-events-none" />
                  <h3 className="font-bold text-white mb-3 sm:mb-4 flex items-center gap-2 text-sm sm:text-base relative z-10">
                    <div className="w-7 h-7 flex items-center justify-center bg-teal-500 rounded-lg">
                      <i className="ri-contacts-line text-white text-sm"></i>
                    </div>
                    聯絡資訊
                    <span className="text-xs font-normal text-gray-400 ml-1">（媒合成功後通知你）</span>
                    <span className="ml-auto text-[10px] font-mono text-teal-400/50">CONTACT_INFO</span>
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-4 relative z-10">
                    <div>
                      <label className="block text-xs font-semibold text-gray-300 mb-2">姓名 <span className="text-red-400">*</span></label>
                      <input type="text" value={contactName} onChange={e => setContactName(e.target.value)} placeholder="請輸入姓名"
                        className={`${inputCls} ${errors.contactName ? 'border-red-500' : ''}`} />
                      {errors.contactName && <p className="mt-1 text-xs text-red-400">{errors.contactName}</p>}
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-gray-300 mb-2">電話 <span className="text-red-400">*</span></label>
                      <input type="tel" value={contactPhone} onChange={e => setContactPhone(e.target.value)} placeholder="0912-345-678"
                        className={`${inputCls} ${errors.contactPhone ? 'border-red-500' : ''}`} />
                      {errors.contactPhone && <p className="mt-1 text-xs text-red-400">{errors.contactPhone}</p>}
                    </div>
                    <div className="sm:col-span-2">
                      <label className="block text-xs font-semibold text-gray-300 mb-2">Email <span className="text-red-400">*</span></label>
                      <input type="email" value={contactEmail} onChange={e => setContactEmail(e.target.value)} placeholder="example@email.com"
                        className={`${inputCls} ${errors.contactEmail ? 'border-red-500' : ''}`} />
                      {errors.contactEmail && <p className="mt-1 text-xs text-red-400">{errors.contactEmail}</p>}
                    </div>
                  </div>

                  {/* LINE */}
                  <div className="border-t border-gray-700 pt-4 relative z-10">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="inline-flex w-5 h-5 items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#06C755' }}>
                        <i className="ri-line-fill text-white text-[10px]"></i>
                      </span>
                      <p className="text-xs font-black text-white">LINE 通知設定</p>
                    </div>
                    <div className="grid grid-cols-2 gap-2 mb-4">
                      <div className="rounded-xl border-2 border-[#06C755]/30 bg-[#06C755]/5 p-3">
                        <div className="flex items-center gap-1.5 mb-1.5">
                          <div className="w-5 h-5 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#06C755' }}>
                            <i className="ri-check-line text-white text-[9px]"></i>
                          </div>
                          <span className="text-xs font-black" style={{ color: '#06C755' }}>已加入 LINE OA</span>
                        </div>
                        <p className="text-xs text-gray-300 leading-relaxed">配對成功時<br /><strong className="text-white">直接在 LINE 收到通知</strong></p>
                        <div className="mt-2 flex items-center gap-1">
                          <i className="ri-flashlight-fill text-amber-400 text-xs"></i>
                          <span className="text-[10px] text-amber-400 font-bold">即時推送</span>
                        </div>
                      </div>
                      <div className="rounded-xl border-2 border-gray-600 bg-gray-900/60 p-3">
                        <div className="flex items-center gap-1.5 mb-1.5">
                          <div className="w-5 h-5 flex items-center justify-center rounded-full bg-gray-600 flex-shrink-0">
                            <i className="ri-close-line text-white text-[9px]"></i>
                          </div>
                          <span className="text-xs font-black text-gray-400">未加入</span>
                        </div>
                        <p className="text-xs text-gray-400 leading-relaxed">配對結果只會<br /><strong className="text-gray-300">出現在 Email 收件夾</strong></p>
                        <div className="mt-2 flex items-center gap-1">
                          <i className="ri-mail-line text-gray-500 text-xs"></i>
                          <span className="text-[10px] text-gray-500 font-medium">可能被歸入垃圾信</span>
                        </div>
                      </div>
                    </div>
                    <a href="https://line.me/R/ti/p/@381szuhf" target="_blank" rel="noopener noreferrer"
                      className="flex items-center justify-between w-full px-4 py-3.5 rounded-xl text-white text-sm font-black cursor-pointer whitespace-nowrap transition-opacity hover:opacity-90"
                      style={{ backgroundColor: '#06C755' }}>
                      <div className="flex items-center gap-2.5">
                        <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg">
                          <i className="ri-line-fill text-white text-lg"></i>
                        </div>
                        <div className="text-left">
                          <p className="text-sm font-black text-white leading-none">加入 LINE 官方帳號</p>
                          <p className="text-[10px] text-white/70 mt-0.5">確保第一時間收到配對通知</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-1 bg-white/20 rounded-full px-2.5 py-1">
                        <i className="ri-user-add-line text-white text-xs"></i>
                        <span className="text-xs text-white font-bold">立即加入</span>
                      </div>
                    </a>
                    <p className="text-[10px] text-gray-500 mt-2 text-center">已加入過的朋友不需重複加入，直接送出需求即可</p>
                  </div>

                  {/* lineId 隱藏欄位供後端使用（保留相容性）*/}
                  <input type="hidden" value={lineId} onChange={e => setLineId(e.target.value)} />
                </div>

                {/* 提交按鈕 */}
                <div className="relative">
                  <div className="absolute inset-0 rounded-2xl blur-xl bg-teal-500/20 scale-95 pointer-events-none"></div>
                  <button type="submit" disabled={isSubmitting}
                    className="relative w-full py-3.5 sm:py-4 bg-teal-500 hover:bg-teal-400 text-white disabled:opacity-60 rounded-2xl font-black text-base sm:text-lg flex items-center justify-center gap-2 sm:gap-3 transition-colors cursor-pointer whitespace-nowrap border border-teal-400/50">
                    {isSubmitting ? (
                      <><i className="ri-loader-4-line animate-spin text-lg sm:text-xl"></i>AI 比對中...</>
                    ) : (
                      <><i className="ri-sparkling-2-fill text-lg sm:text-xl"></i>送出需求，開始 AI 媒合<i className="ri-arrow-right-line text-lg sm:text-xl"></i></>
                    )}
                  </button>
                </div>
                <p className="text-center text-xs text-gray-500 -mt-4">
                  提交即表示您同意接收媒合通知，我們不會將您的資料提供給第三方
                </p>

              </form>
            </>
          )}
        </div>
      </section>

      {/* 底部 CTA */}
      <section className="relative py-10 sm:py-12 bg-gradient-to-r from-teal-600 to-teal-700 overflow-hidden">
        <TechGlowEffect intensity="subtle" className="absolute inset-0 overflow-hidden pointer-events-none" />
        <div className="max-w-3xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 sm:gap-5 relative z-10">
          <div>
            <p className="text-white/80 text-xs font-semibold mb-1">你是屋主嗎？</p>
            <h3 className="text-white font-black text-lg sm:text-xl">有房子想出租？立即免費刊登</h3>
            <p className="text-white/70 text-xs sm:text-sm mt-1">零仲介費 · AI 自動撰稿 · 等待中的租客馬上收到通知</p>
          </div>
          <Link to="/publish"
            className="flex-shrink-0 inline-flex items-center gap-2 px-7 py-3.5 bg-white text-teal-600 rounded-full font-black text-sm hover:bg-opacity-90 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-home-4-line text-base"></i>免費刊登房源<i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      <Footer />

      {showLineModal && (
        <LineOaModal mode="tenant" onClose={() => setShowLineModal(false)} />
      )}
    </div>
  );
}
